var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64209 1.24219L5.86475 4.87891L1.84521 5.45312C1.13428 5.5625 0.86084 6.4375 1.38037 6.95703L4.25146 9.77344L3.56787 13.7383C3.4585 14.4492 4.22412 14.9961 4.85303 14.668L8.43506 12.7812L11.9897 14.668C12.6187 14.9961 13.3843 14.4492 13.2749 13.7383L12.5913 9.77344L15.4624 6.95703C15.9819 6.4375 15.7085 5.5625 14.9976 5.45312L11.0054 4.87891L9.20068 1.24219C8.8999 0.613281 7.97021 0.585938 7.64209 1.24219Z",
    fill: "#F3A524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.62712a92f9b7c5ef0c4036c4547cdb12.svg";
export { ForwardRef as ReactComponent };